// extracted by mini-css-extract-plugin
export default {"serving":"zuxDMB6QXEyVJtXsBGDa"};